// Percorso file: src/components/clubLinks.js
//
// GLI INDIRIZZI DEL CLUB — sede unica.
//
// I quattro canali del club (doc 07 §7.3) e il negozio non sono di una
// home in particolare: compaiono su tutte, e finché stavano dichiarati
// dentro HomeSuperadmin.jsx ogni home nuova doveva ricopiarseli. Sono
// indirizzi del mondo reale: cambiano fuori dall'app, senza preavviso, e
// quattro copie che cambiano in tre posti sono un difetto che si vede
// solo quando qualcuno tocca il collegamento sbagliato.
//
// Qui non c'è nessun disegno: solo i dati. Il markup (la riga
// `.qpsc-social`, il pulsante oro dello Shop) resta nelle pagine, con le
// classi condivise di HomeShell.css. Le icone sono Font Awesome via
// react-icons (§5: emoji abolite) e viaggiano insieme all'indirizzo,
// perché il canale e il suo glifo sono lo stesso dato.
//
// Il file è `.js` e non `.jsx` di proposito: non contiene JSX: i
// componenti-icona si passano per riferimento, non si disegnano.

import { FaGlobe, FaInstagram, FaFacebookF, FaYoutube } from "react-icons/fa";

/** §7.3 i quattro canali del club, stessi indirizzi delle home vecchie. */
export const SOCIAL = [
  { href: "https://www.queensparksc.com.au", title: "Website", Icon: FaGlobe },
  {
    href: "https://www.instagram.com/queensparksc/",
    title: "Instagram",
    Icon: FaInstagram,
  },
  {
    href: "https://www.facebook.com/queensparksc",
    title: "Facebook",
    Icon: FaFacebookF,
  },
  {
    href: "https://www.youtube.com/@QueensParkSC",
    title: "YouTube",
    Icon: FaYoutube,
  },
];

/** Il negozio del club: unica voce esterna delle home (§5.1 accento). */
export const SHOP_URL = "https://qpsc-store.square.site/s/shop";
